<template>
  <div class="resumo-container-sticky">
    <div class="resumo-container-relative">
      <div
        @mouseover="resumoHover(true)"
        @mouseleave="resumoHover(false)"
        @click="trocaResumo"
        v-b-tooltip.hover.top
        title="Resumo Dados Cenário"
        class="resumo-icone"
      >
        <Transition name="fadeButton" tag="div" class="icone-resumo-container">
          <font-awesome-icon
            class="icone-resumo"
            key="abre"
            v-if="!botaoResumoHover || mostraCamposC"
            icon="file-invoice"
          />
          <font-awesome-icon class="icone-resumo" key="fecha" v-else icon="times-circle" />
        </Transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IconeResumo",
  props: {
    resumoHover: Function,
    trocaResumo: Function,
    botaoResumoHover: Boolean,
    mostraCamposC: Boolean
  }
};
</script>

<style lang="scss" scoped>
.resumo-container-sticky {
  position: sticky;
  top: 0;
  z-index: 500;
  transform: translateZ(0);
}
.resumo-container-relative {
  position: relative;
}
.resumo-icone {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 20px;
  width: 40px;
  height: 40px;
  background: #484848;
  color: var(--branco);
  position: absolute;
  top: 0px;
  left: -55px;
  box-shadow: 2px 2px 4px #cccccca1;
  scroll-behavior: smooth;
  &:hover {
    cursor: pointer;
  }
}
.fadeButton-enter-active,
.fadeButton-leave-active {
  transition: all 0.3s ease;
}
.fadeButton-enter,
.fadeButton-leave-to {
  opacity: 0;
}
.icone-resumo-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.icone-resumo {
  position: absolute;
}
</style>
